"use strict";
var settings = require('ofs/settings');


var trackFacebook = function(tag_id, value, currency) {
  if (settings.tracking.gactive && settings.tracking.facebookTracking) {

    var _fbq = window._fbq || [];
    _fbq.push(['track', tag_id, {'value':value, 'currency': currency}]);

  } else {
    console.log('Facebook tracking disabled (tag_id:' + tag_id + ')');
  }
};

module.exports = trackFacebook;


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/core/utils/tracking/facebook.js
 **/